import { useTranslation } from 'react-i18next';
import { Text, Button } from '@/ui';
import { Modal } from '@/components/Modal/Modal';
import { Row } from '@/components/SettingsLayout';
import { useMarkFeesReportAsPaidMutation } from '@/store/slices/pricingSlice';
import { toast } from 'react-hot-toast';

type MarkAsPaidModalProps = {
  open: boolean;
  onClose: () => void;
  reportId: string;
  companyId: string;
  onSuccess?: () => void;
};

function MarkAsPaidModal({ open, onClose, reportId, companyId, onSuccess }: MarkAsPaidModalProps) {
  const { t } = useTranslation();
  const [markAsPaid, { isLoading: isMarkingAsPaid }] = useMarkFeesReportAsPaidMutation();

  const handleMarkAsPaid = () => {
    markAsPaid({
      feesReportId: reportId,
      companyId,
    })
      .unwrap()
      .then(() => {
        toast.success(t('Residuals.mark_as_paid_success'));
        onSuccess?.();
        onClose();
      })
      .catch(() => {
        toast.error(t('Residuals.mark_as_paid_error'));
      });
  };

  return (
    <Modal open={open} closeModal={onClose}>
      <Modal.Title title={t('Residuals.modal_title')} />
      <Modal.Content border={true}>
        <Text size='m' weight='light-medium'>
          {t('Residuals.modal_message')}
        </Text>
      </Modal.Content>
      <Modal.Footer justify='flex-end'>
        <Row gapSize='8' fullWidth={false}>
          <Button variant='cancel' onClick={onClose} disabled={isMarkingAsPaid}>
            {t('ModalBuilder.cancel')}
          </Button>
          <Button variant='primary' onClick={handleMarkAsPaid} disabled={isMarkingAsPaid}>
            {t('ModalBuilder.confirm')}
          </Button>
        </Row>
      </Modal.Footer>
    </Modal>
  );
}

export default MarkAsPaidModal;
